<template>
    <div class="subscribers--container">
        <data-container>
            <template #controls>
                <AppDropdown
                    placeholder="Select"
                    v-model="filter.sort_by"
                    :options="sortItems"
                    @input="fetchSubscriberList"
                >
                    Sort by
                </AppDropdown>
                    <div class="right--controls">
                        <AppButton modifier="small-primary" @click="showBindAccount">
                            Bind Accounts
                        </AppButton>
                        <AppTextField
                            v-model="filter.search"
                            placeholder="Type here"
                            icon-right="search"
                            @input="search"
                        />
                    </div>
            </template>
            <template #content>
                <AppTable
                    :dataset="subscriberList.data"
                    :fields="fields"
                    :selected="selectedItems"
                    :loading="isLoading"
                    @select="selectedItems = $event"
                    @endOfScroll="message('end of scroll')"
                    :total-count="subscriberList.total"
                    :current-page="parseInt(filter.page)"
                    :items-per-page="parseInt(filter.count)"
                    @changePage="changePage"
                />
            </template>
        </data-container>

         <AppPopup
                type="success"
                :visible="showBindAccountForm"
                @close="showBindAccountForm = false"
            >
                <div class="binding-form">
                    <h3>Bind Account</h3>
                    <hr>
                    <label>Accounts</label>
                    <AppDropdown
                        searchable
                        customSearch
                        placeholder="Select Accounts"
                        display-prop="name"
                        v-model="form.account"
                        @search="searchList('user', $event)"
                        :options="users.data"
                        :loading="userIsLoading"
                        :disabled="userIsLoading"
                        @end-of-scroll="userIsLoading ? null :fetchList('user', userFilter.page)"
                    >
                        <template #option="{ props: { option } }">
                            <div class="account">
                                <span class="name">{{ option.name }}</span>
                                <span>{{ option.email }}</span>
                            </div>
                        </template>
                    </AppDropdown>
                    <label>Subscription Plan</label>
                    <AppDropdown
                        searchable
                        customSearch
                        placeholder="Select Plan"
                        display-prop="name"
                        v-model="form.plan"
                        :options="plans.data"
                        :loading="planIsLoading"
                        :disabled="planIsLoading"
                        @search="searchList('plan', $event)"
                        @end-of-scroll="planIsLoading ? null :fetchList('plan', planFilter.page)"
                    >
                    </AppDropdown>

                    <div class="actions">
                        <AppButton modifier="small-danger" @click="showBindAccountForm = false" :disabled="submitLoading"
                        >
                            Close
                        </AppButton>
                        <AppButton modifier="small-primary" @click="submitBinding" :disabled="submitLoading"
                        >
                            Confirm
                        </AppButton>
                    </div>
                </div>
            </AppPopup>
    </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import AppTable from '@/components/AppTable'
import AppPopup from '@/components/AppPopup'
import AppDropdown from '@/components/AppDropdown'
import subscriber from '@/store/subscriber/app.js'
import { bindingAccountFields, sortItems } from '@/utils/meta.js'
import { setQueryParams } from '@/utils/helpers.js'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			selectedItems: []
		}
	},

	methods: {
		submitBinding () {
			const form = new FormData()
			form.set('account_id', this.form.account.id)
			form.set('plan_id', this.form.plan.id)
			this.$store.dispatch('subscriber/subscribe', form)
		},
		search (val) {
			this.filter.page = 1
			this.filter.keyword = val
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.fetchSubscriberList()
			}, 300)
		},

		fetchSubscriberList () {
		    const query = { ...this.filter }
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			query.theme_filter && (query.theme_filter = query.theme_filter.join('|'))
			this.$router.push({ query })
			const queryStr = setQueryParams(this.filter)
		    this.$store.dispatch('subscriber/list', queryStr.toLowerCase())
		},
		changePage ({ currentPage, itemsPerPage }) {
			this.filter.page = currentPage
			itemsPerPage !== this.filter.count && (this.filter.page = 1)
			this.filter.count = itemsPerPage
			this.fetchSubscriberList()
		},
		async showBindAccount () {
			this.showBindAccountForm = true
			this.users = {
				data: [],
				last_page: 0,
				total: 0,
				to: 0,
				from: 0
			}
			this.plans = {
				data: [],
				last_page: 0,
				total: 0,
				to: 0,
				from: 0
			}
			this.userFilter = {
				keyword: '',
				page: 1,
				count: 10
			}
			this.planFilter = {
				keyword: '',
				page: 1,
				count: 10
			}
			this.form = {
				account: '',
				plan: ''
			}
			this.fetchList('user')
			this.fetchList('plan')
		},
		fetchList (key, _page) {
			const { last_page } = this[`${key}s`]
			if (this[`${key}Filter`].page === last_page) return
			if (_page) {
				this[`${key}Filter`].page = ++_page
			}
			const { page, count, keyword } = this[`${key}Filter`]
			const query = `?page=${page}&count=${count}&keyword=${keyword}`
			this.$store.dispatch(`subscriber/${key}List`, query)
		},
		searchList (key, keyword) {
			if (key === 'user') {
				this.users = {
					data: [],
					last_page: 0,
					total: 0,
					to: 0,
					from: 0
				}
			} else {
				this.plans = {
					data: [],
					last_page: 0,
					total: 0,
					to: 0,
					from: 0
				}
			}
			this[`${key}Filter`].page = 1
			this[`${key}Filter`].keyword = keyword
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.fetchList(key)
			}, 600)
		}
	},
	computed: {
		...mapGetters('subscriber', [
			'subscriberList',
			'isLoading',
			'submitLoading',
			'userIsLoading',
			'planIsLoading'
		]),
		...mapFields('subscriber', [
			'users',
			'plans',
			'form',
			'filter',
			'userFilter',
			'planFilter',
			'showBindAccountForm',
			'progress'
		]),
		fields () { return bindingAccountFields },
		sortItems () { return sortItems },
		subscriberPageCounter () {
			const { to, from } = this.subscriberList
			return `${from || 0} - ${to || 0}`
		}
	},
	created () {
		const query = { ...this.$route.query }
		if (Object.keys(query).length) {
			Object.keys(query).forEach(key => {
				if (query[key] && key === 'theme_filter') {
					query[key] = query[key].split('|')
				} else {
					!query[key] && (delete query[key])
				}
			})
			this.filter = { ...query }
		}
		this.fetchSubscriberList()
	},
	beforeCreate () {
		if (!this.$store.hasModule('subscriber')) {
			this.$store.registerModule('subscriber', subscriber)
		}
	},
	components: {
		DataContainer,
		AppButton,
		AppTextField,
		AppTable,
		AppPopup,
		AppDropdown
	}
}
</script>

<style lang="scss" scoped>
.subscribers--container {
    padding: 1.5em;
}

.binding-form {
    width: 100%;
    label {
        color: $dark;
        margin-top: 24px;
        margin-bottom: 8px;
        display: block;
    }

    .app-dropdown {
        width: 100%;

        .account {
            width: 100%;
            padding: 4px 8px;

            span {
                display: block;
                margin-top: 8px;
                font-size: 12px;

                &.name {
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

    }
    ::v-deep .app-dropdown__options {
        max-height: 300px;
    }

    .actions {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;

    .app-button:not(:last-of-type) {
        margin-right: 8px;
    }
}
}

.app-dropdown {
    min-width: 120px;
}

.custom-table {
    margin-top: 12px;
}

.right--controls{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    .app-button--small-primary {
        margin-right: 12px;
    }
}

/deep/ .app-popup {
    width: 30em;
    padding: 16px 0;
}

.app-count-picker {
    margin-right: 5px;
}

.pagination--counter {
    display: flex;
    flex: 1;
    font-size: 1.2em;
}
</style>
